import axios from 'axios';

const SCA_URL = process.env.REACT_APP_SCA_URL;

export interface LoginRequest {
  login: string;
  password: string;
}

export interface RegisterRequest {
  email: string;
  first_name: string;
  last_name: string;
  company_name: string;
  password: string;
}

export interface LoginResponse {
  access_token: string;
  refresh_token: string;
}

export interface RefreshTokenRequest {
  refresh_token: string;
}

export interface UserMeResponse {
  id: string;
  email: string | null;
  status: string | null;
  role: string | null;
  first_name: string | null;
  last_name: string | null;
  last_login: string | null;
  created: string | null;
  modified: string | null;
  company: {
    id: string;
    name: string;
    status: string;
    details: any;
    settings: any;
  };
}

export const login = async (
  credentials: LoginRequest,
): Promise<LoginResponse> => {
  const response = await axios.post(`${SCA_URL}/v1/auth/login`, credentials);
  return response.data;
};

export const register = async (data: RegisterRequest): Promise<void> => {
  const response = await axios.post(`${SCA_URL}/v1/auth/register`, data);
  return response.data;
};

export const refreshToken = async (
  refreshTokenData: RefreshTokenRequest,
): Promise<LoginResponse> => {
  const response = await axios.post(
    `${SCA_URL}/v1/auth/refresh`,
    refreshTokenData,
  );
  return response.data;
};

export const getUserMe = async (token: string): Promise<UserMeResponse> => {
  const response = await axios.get(`${SCA_URL}/v1/auth/me`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const logout = async (
  refreshTokenData: RefreshTokenRequest,
): Promise<void> => {
  const response = await axios.post(
    `${SCA_URL}/v1/auth/logout`,
    refreshTokenData,
  );
  return response.data;
};

export const resetPassword = async (data: { email: string }): Promise<void> => {
  const response = await axios.post(
    `${SCA_URL}/v1/auth/password/reset`,
    data,
  );
  return response.data;
};

export const setPasswordWithCode = async (data: {
  code: string;
  password: string;
}): Promise<void> => {
  const response = await axios.post(`${SCA_URL}/v1/auth/password`, data);
  return response.data;
};

export const checkConfirmCode = async (data: {
  code: string;
}): Promise<void> => {
  await axios.post(`${SCA_URL}/v1/auth/confirm_code/check`, data);
};

export const resendConfirmCode = async (data: {
  code: string;
}): Promise<void> => {
  await axios.post(`${SCA_URL}/v1/auth/confirm_code/resend`, data);
};
